import { EntityApiDefinitionCard, EntityConsumingComponentsCard, EntityProvidingComponentsCard } from '@backstage/plugin-api-docs';
import { EntityAboutCard, EntityLayout } from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';
import React from 'react';

const OverviewContent = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <EntityAboutCard />
      </Grid>
      <Grid item xs={12} md={6}>
        <EntityProvidingComponentsCard />
      </Grid>
      <Grid item xs={12} md={6}>
        <EntityConsumingComponentsCard />
      </Grid>
    </Grid>
  );
};

export const ApiPage = () => {
  return (
    <EntityLayout UNSTABLE_contextMenuOptions={{ disableUnregister: 'hidden' }}>
      <EntityLayout.Route path="/" title="Overview">
        <OverviewContent />
      </EntityLayout.Route>
      <EntityLayout.Route path="/definition" title="Definition">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <EntityApiDefinitionCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
    </EntityLayout>
  );
};
